__turbopack_context__.v({
  "dot": "_2GvZHG_dot",
  "emeraldLoadingPulse": "_2GvZHG_emeraldLoadingPulse",
  "wrap": "_2GvZHG_wrap",
});
